module.exports = __webpack_public_path__ + "img/1201.7c6ce7d7.jpg";